export default {
  button: {
    boxSizing: 'border-box',
    minWidth: 0,
    border: 0
  },
  label: {
    fontSize: '12px',
    lineHeight: '12px',
    fontFamily: 'Roboto, sans-serif',
    textTransform: 'initial'
  }
};
